import { render, staticRenderFns } from "./MaterialBom.vue?vue&type=template&id=0eb7b09d&scoped=true"
import script from "./MaterialBom.vue?vue&type=script&lang=js"
export * from "./MaterialBom.vue?vue&type=script&lang=js"
import style0 from "./MaterialBom.vue?vue&type=style&index=0&id=0eb7b09d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb7b09d",
  null
  
)

export default component.exports